import Icon from '../components/Icon.vue'

Icon.register({"long-arrow-left":{"width":1792,"height":1792,"paths":[{"d":"M1792 800v192q0 14-9 23t-23 9h-1248v224q0 21-19 29t-35-5l-384-350q-10-10-10-23 0-14 10-24l384-354q16-14 35-6 19 9 19 29v224h1248q14 0 23 9t9 23z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/long-arrow-left.js
// module id = 0d25
// module chunks = 0